function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Logger } from './base';
export var SystemLogsCollection = /*#__PURE__*/ function(SystemLogsCollection) {
    SystemLogsCollection["OutgoingRequests"] = "OutgoingRequests";
    return SystemLogsCollection;
}({});
export class SystemLoggerTelemetry extends Logger {
    info({ collection = "OutgoingRequests", event }) {
        this.log('Info', collection, _object_spread({}, event));
    }
    debug({ collection = "OutgoingRequests", event }) {
        this.log('Debug', collection, _object_spread({}, event));
    }
    error({ collection = "OutgoingRequests", event }) {
        this.log('Error', collection, _object_spread({}, event));
    }
    warning({ collection = "OutgoingRequests", event }) {
        this.log('Warn', collection, _object_spread({}, event));
    }
}
